<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="total-stat">
    <div class="total-stat-count">
      <span :class="alertType">{{ kpiFormat(longestWaitingTime, 'time') }}</span>
    </div>
    <div v-once class="total-stat-description">{{ $t('longestWaitingTime') }}</div>

    <div :class="blinkClass + ' current-bp-name'">{{ currentBpName }}</div>

    <div class="total-stat-description total-stat-description--media-type">
      <span v-for="(media, i) in slide.mediaTypes" :key="media">
        {{ media }}<span v-if="i < slide.mediaTypes.length - 1">, </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';

export default {
  name: 'EcsLongestWaitingTimeSlide',

  mixins: [EcsKpiFormatter],

  props: {
    slide: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      currentBpName: '',
      blinkClass: '',
      blinkCount: 0,
      blinkTimer: null
    };
  },

  computed: {
    ...mapGetters('WALLBOARD', ['getStatisticsByBpids', 'getBpName']),

    alertType() {
      return 'alert-type-' + this.selectedBusinessProcessesStats.longestWaitingTime.alertType.toLowerCase();
    },

    selectedBusinessProcessesStats() {
      return this.getStatisticsByBpids(this.slide.businessProcesses);
    },

    longestWaitingTime() {
      /* Prevent case sensitive issues */
      const mediaTypes = this.slide.mediaTypes.map(mediaType => mediaType.toLowerCase());

      if (!this.selectedBusinessProcessesStats) {
        return this.slide;
      }

      return this.filteredLongestWaitingTimeByMediaType(
        this.selectedBusinessProcessesStats.longestWaitingTime,
        mediaTypes
      );
    }
  },

  mounted() {
    this.startBlinkTimer();
  },

  beforeDestroy() {
    clearInterval(this.blinkTimer);
  },

  methods: {
    filteredLongestWaitingTimeByMediaType(totalLWT, mediaTypes) {
      const currentBpName = this.currentBpName;
      const longestWaitingTime = totalLWT.value.dimensionsValues.reduce((longest, current) => {
        if (!mediaTypes.includes(current.name.toLowerCase())) {
          return longest;
        }
        if (this.slide.businessProcesses.length === 1 && longest === 0) {
          this.currentBpName = this.getBpName(this.slide.businessProcesses[0]);
        } else if (longest === 0) {
          this.currentBpName = '';
        }
        if (longest < current.value) {
          this.currentBpName = current.bpName + ' - ' + current.name;
          return current.value;
        } else {
          return longest;
        }
      }, 0);
      if (currentBpName !== this.currentBpName && this.slide.businessProcesses.length > 1 && longestWaitingTime > 0) {
        this.blinkClass = 'blink';
        this.blinkTimer = 0;
      }

      return longestWaitingTime;
    },
    startBlinkTimer() {
      const self = this;
      this.blinkTimer = setInterval(function() {
        if (self.blinkClass === 'blink') {
          if (self.blinkCount >= 3) {
            self.blinkCount = 0;
            self.blinkClass = '';
          } else {
            self.blinkCount++;
          }
        }
      }, 1000);
    }
  }
};
</script>

<style src="../scoped.css" scoped></style>
